<template>
  <div class="home">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      title="商城首页"
      fixed
    />
    
    <!-- 给整体内容添加一个容器，处理固定导航栏的遮挡 -->
    <div class="content">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <van-search
          v-model="searchValue"
          placeholder="搜索商品"
          shape="round"
        />
      </div>

      <!-- 轮播广告 -->
      <div class="banner">
        <van-swipe :autoplay="3000" indicator-color="white">
          <van-swipe-item>
            <img src="@/assets/banner1.png" alt="促销活动">
          </van-swipe-item>
          <van-swipe-item>
            <img src="@/assets/banner2.png" alt="促销活动">
          </van-swipe-item>
        </van-swipe>
      </div>

      <!-- 导航图标 -->
      <div class="nav-icons">
        <div class="nav-item" v-for="(item, index) in navItems" :key="index">
          <van-icon :name="item.icon" :color="item.color" size="24" />
          <span>{{ item.text }}</span>
        </div>
      </div>

      <!-- 热门商品 -->
      <div class="hot-products">
        <div class="section-title"> 热门商品 </div>
        <div class="product-list">
          <div class="product-card" v-for="(product, index) in hotProducts" :key="index" @click="goToDetail(product)">
            <img :src="product.image" :alt="product.title">
            <div class="product-info">
              <div class="product-title">{{ product.title }}</div>
              <div class="tags">
                <span class="tag" v-for="(tag, tagIndex) in product.tags" :key="tagIndex">
                  {{ tag }}
                </span>
              </div>
              <div class="price-container">
                <span class="product-price">¥{{ product.price }}</span>
                <span class="original-price">¥{{ product.originalPrice }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
	<div style="padding-top: 40px;"> <a href="https://beian.miit.gov.cn/">琼ICP备2025057209号-1</a></div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      searchValue: '',
      navItems: [
        { icon: 'phone-o', text: '手机', color: '#ff6b81' },
        { icon: 'desktop-o', text: '电脑', color: '#7bed9f' },
        { icon: 'audio', text: '配件', color: '#70a1ff' },
        { icon: 'clock-o', text: '智能表', color: '#ff7f50' },
        { icon: 'service-o', text: '售后', color: '#5352ed' }
      ],
      hotProducts: [
        {
          title: '新款智能手机',
          price: 2999,
          originalPrice: 3999,
          image: require('@/assets/phone1.png'),
          tags: ['新品', '热销', '爆款']
        }, 
        {
          title: '游戏笔记本',
          price: 5999,
          originalPrice: 6999,
          image: require('@/assets/computer1.png'),
          tags: ['限时特惠', '新品', '爆款']
        },
        {
          title: '新款智能手机',
          price: 2999,
          originalPrice: 3599,
          image: require('@/assets/phone2.png'),
          tags: ['新品', '热销', '爆款']
        },
        {
          title: '游戏笔记本',
          price: 8999,
          originalPrice: 9999,
          image: require('@/assets/computer2.png'),
          tags: ['新品', '热销', '爆款']
        }
      ]
    }
  },
  methods: {
    goToDetail(product) {
      this.$router.push({
        name: 'ProductDetail',
        params: { id: product.id },
        state: { product }
      })
    }
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
  background: #f7f8fa;
}

.content {
  padding-top: 15px; /* 为固定的顶部导航栏留出空间 */
}

.search-bar {
  margin: 10px 0;
}

.banner {
  margin: 10px 0;
}

.banner img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.nav-icons {
  display: flex;
  justify-content: space-around;
  padding: 15px 0;
  background: #fff;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.nav-item span {
  margin-top: 5px;
  font-size: 12px;
  color: #333;
}

.hot-products {
  background: #fff;
  padding: 15px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
}

.product-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.product-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.product-card img {
  width: 100%;
  height: 120px;
  object-fit:cover;
}

.product-info {
  padding: 10px;
}

.product-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
}

.tags {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.tag {
  font-size: 12px;
  padding: 2px 6px;
  background: #fff1f0;
  color: #ff6b81;
  border-radius: 4px;
}

.price-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.product-price {
  color: #ff1b3d;
  font-weight: bold;
}

.original-price {
  color: #999;
  font-size: 12px;
  text-decoration: line-through;
}
</style>